<template>
    <div>
        <button class="btn purchase" type="button" @click="BillingPurchase">
            <div class="overlay"></div>
            <strong>
                {{ btnText }}
            </strong>
        </button>
        <button class="btn example" type="button" @click="GoToSampleReport">
            <strong>還不確定要不要解鎖?先看完整範例報告
                <CIcon name="cil-arrow-right" height="20" />
            </strong>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        btnText: {
            type: String,
            require: true
        }
    },
    methods: {
        BillingPurchase(){   
            let currentRouterName = this.$router.currentRoute.name;
            this.$router.push({
                name: "MyAccount",
                params: { OutSidePurchaseModal: true,TriggerRouterName: currentRouterName  }
            });
        },
        GoToSampleReport() {
            window.open(`/marketReportResult?action=showSampleReport`, '_blank');
        }
    }
} 
</script>

<style lang="scss" scoped>
div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    display: flex;
    flex-direction: column;

    > .purchase {
        width: 100%;
        min-height: 50px;
        background: linear-gradient(
            90deg,
            rgb(22, 70, 70) 0%,
            rgb(44, 122, 113) 30%,
            rgb(79, 158, 112) 60%,
            rgb(250, 153, 107) 100%
        );
        position: relative;
        color: white;
        padding: 0;
        border: none;
        border-radius: 12px;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        transition: 0.3s;

        @media(max-width: '1000px') {
            min-width: 300px;
        }

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='1.5' numOctaves='5' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.5'/%3E%3C/svg%3E");
            opacity: 0.9;
            mix-blend-mode: multiply;
            pointer-events: none;
        }

        &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: 
                /* Bottom-left corner stars cluster - with increased brightness */
                radial-gradient(circle at 10% 85%, rgba(255, 255, 255, 1) 0.01%, transparent 0.06%),
                radial-gradient(circle at 5% 90%, rgba(255, 255, 255, 1) 0.01%, transparent 0.04%),
                radial-gradient(circle at 8% 88%, rgba(255, 255, 255, 1) 0.005%, transparent 0.03%),
                radial-gradient(circle at 12% 93%, rgba(255, 255, 255, 1) 0.01%, transparent 0.05%),
                radial-gradient(circle at 15% 85%, rgba(255, 255, 255, 1) 0.007%, transparent 0.035%),
                
                /* Additional brighter stars in bottom-left */
                radial-gradient(circle at 7% 91%, rgba(255, 255, 255, 1) 0%, transparent 0.025%),
                radial-gradient(circle at 13% 86%, rgba(255, 255, 255, 1) 0%, transparent 0.02%),
                
                /* Top-right corner stars cluster - with increased brightness */
                radial-gradient(circle at 90% 5%, rgba(255, 255, 255, 1) 0.01%, transparent 0.06%),
                radial-gradient(circle at 95% 10%, rgba(255, 255, 255, 1) 0.01%, transparent 0.04%),
                radial-gradient(circle at 93% 8%, rgba(255, 255, 255, 1) 0.005%, transparent 0.03%),
                radial-gradient(circle at 88% 3%, rgba(255, 255, 255, 1) 0.01%, transparent 0.05%),
                radial-gradient(circle at 92% 12%, rgba(255, 255, 255, 1) 0.007%, transparent 0.035%),
                
                /* Additional brighter stars in top-right */
                radial-gradient(circle at 87% 7%, rgba(255, 255, 255, 1) 0%, transparent 0.025%),
                radial-gradient(circle at 93% 4%, rgba(255, 255, 255, 1) 0%, transparent 0.02%),
                
                /* Scattered stars elsewhere - slightly brighter */
                radial-gradient(circle at 50% 20%, rgba(255, 255, 255, 0.7) 0.05%, transparent 0.12%),
                radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.6) 0.05%, transparent 0.12%),
                radial-gradient(circle at 30% 40%, rgba(255, 255, 255, 0.5) 0.01%, transparent 0.04%);
            pointer-events: none;
        }

        > .overlay {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 50%;
            bottom: 0;
            left: 50%;
            right: 0;
            transform: translate(-50%, -50%);
            background-color: rgba(0, 0, 0, 0); /* 初始透明 */
            transition: background-color 0.3s ease;
            border-radius: 12px;
        }

        /* hover 時調暗 */
        &:hover .overlay {
            background-color: rgba(0, 0, 0, 0.3); /* 遮罩變半透明黑色 */
        }

        > strong {
            position: relative;
            z-index: 3;
            color: white;
        }
    }

    > .example {
        color: #000;
        
        :hover {
            transition: transform 0.3s ease;

            svg {
                transform: translateX(10px);
            }
        }
    }
}
</style>